module.exports = __webpack_public_path__ + "img/register-active.b08813b8.svg";